import React from "react";
import "./table.css";

const tableData = [
  ["アカウント作成", "", "✔︎", ""],
  ["アカウント権限付与", "", "✔︎", ""],
  ["商品情報提供", "", "✔︎", ""],
  ["商品画像表示書作成", "✔︎", "", ""],
  ["商品画像デザイン", "✔︎", "", "✔︎"],
  ["カタログ登録作業", "✔︎", "", ""],
  ["商品説明文SEO対策", "✔︎", "", ""],
  ["検索対策KW選定", "✔︎", "", ""],
  ["商品紹介コンテンツ作成", "✔︎", "", ""],
  ["在庫納品作業", "", "✔︎", ""],
  ["在庫状況把握", "✔︎", "", ""],
  ["競合セラー調査D監視", "✔︎", "", ""],
  ["商品レビュー依頼", "✔︎", "", ""],
  ["ギフティング施策実施", "✔︎", "", "✔︎"],
  ["カスタマーサポート", "✔︎", "✔︎", ""],
  ["セール出稿", "✔︎", "", ""],
  ["オート広告運用", "✔︎", "", ""],
  ["アニュアル販促案", "✔︎", "", ""],
  ["外部広告（SNS・動画）ご提案", "✔︎", "", ""],
  ["外部広告運用", "✔︎", "", ""],
  ["競合商品調査", "✔︎", "", ""],
  ["売上レポート作成", "✔︎", "", ""],
];

export default function AmzTableSection() {
  return (
    <section id="menu" className="amz-table-section">
      {/* タイトル */}
      <div className="amz-table-title">
      Amazon・Rakuten運用代行メニューの役割分担
      </div>
      {/* ヘッダー（固定部分） */}
      <div className="amz-table-header-wrap">
        <table className="amz-table amz-table-header">
          <thead>
            <tr>
              <th style={{ width: "40%" }}>作業</th>
              <th style={{ width: "20%" }}>弊社</th>
              <th style={{ width: "20%" }}>御社</th>
              <th style={{ width: "20%" }}>
                外注<br />
                <span style={{ fontSize: "0.8em" }}>(お客様に応じて)</span>
              </th>
            </tr>
          </thead>
        </table>
      </div>
      {/* 本体（縦スクロール部分） */}
      <div className="amz-table-wrap">
        <table className="amz-table amz-table-body">
          <tbody>
            {tableData.map((row, i) => (
              <tr key={i}>
                {row.map((cell, j) => (
                  <td key={j} style={{
                    width: j === 0 ? "40%" : "20%"
                  }}>
                    {cell === "✔︎" ? (
                      <span className="amz-table-check">✔︎</span>
                    ) : (
                      cell
                    )}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {/* 下部説明 */}
      <div className="amz-table-bottom">
        <div className="amz-table-bottom-title">
        Amazon・Rakuten運営で丸投げを実現し、<span>“リソース不足を解消”</span>
        </div>
        <div className="amz-table-bottom-desc">
        Amazon・Rakuten運用（運営）代行では、お客様はアカウントの作成や権限付与、在庫の納品さえしていただければあとはAmazonを熟知したのAmazon・Rakuten運用担当者がほぼすべての業務を代行いたします。
          <br /><br />
          弊社商品を魅力的に伝える商品登録はもちろんのこと<br />
          SEO対策や日々の売上推移の確認、プロモーション施策の提案、セールの実行、さらに広告の運用代行もAmazon・Rakutenアカウント運用代行に含まれます。（周囲広告等の未着まで）<br />
          Amazon・Rakutenの知識やノウハウを持っていない方や売上が低迷している方は
          <br />
          ぜひこのAmazon・Rakuten運用代行に任せることで、
          <br />
          ご自身の手を動かすことなくAmazon・Rakutenのプロに運用を任せることができます。
        </div>
      </div>
    </section>
  );
}